module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }), _vm._v("‘She possessed, in the highest degree, all the qualities which were required in a great Prince.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IOVANNI")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CARAMELLI")]), _vm._v(", Venetian Ambassador to the Court of Elizabeth Tudor, Queen of England")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("‘I would have you know that this kingdom of mine is not so scant of men but there be a rogue or two among them.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LIZABETH")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDOR")]), _vm._v(", Queen of England")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0ee4ffc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780795338557_epub_epi_r1.vue
// module id = 72
// module chunks = 0